export const ModalTypes = Object.freeze({
    TextModal: 'text_with_button',
    ImageCarousel: 'image_carousel',
});

